var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChargeZoneRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f6f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 82.83,
    y1: -737.81,
    x2: 44.31,
    y2: -737.81,
    gradientTransform: "translate(0 -696) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 29.43,
    y1: -735.98,
    x2: 76.97,
    y2: -735.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 863.03,
    y1: 14089.26,
    x2: 836.25,
    y2: 14047.67,
    gradientTransform: "translate(12348.12 -6848.78) rotate(-122.78) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.45,97.66c-2.89-2.36-6.33-3.87-9.96-4.73-9.35-2.2-16.32-10.61-16.32-20.61V22C10.16,10.3,19.64.82,31.34.82h50.33c11.69,0,21.17,9.48,21.17,21.17v50.33c0,10.01-6.98,18.41-16.32,20.61-3.63.85-7.07,2.37-9.96,4.73l-16.09,13.11c-2.31,1.88-5.61,1.88-7.92,0l-16.09-13.11Z",
    fill: "#ff2e2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.51,10.2h50.15c6.51,0,11.8,5.29,11.8,11.8v50.33c0,6.51-5.29,11.8-11.8,11.8H31.34c-6.51,0-11.8-5.29-11.8-11.8V22.17c0-6.61,5.37-11.97,11.97-11.97Z",
    fill: "url(#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m59.22,36.26l-.13-.09c.06.06.11.09.13.09Z",
    fill: "#000050"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m60.55,56.15l.13-.09c-.08.04-.13.07-.13.09Z",
    fill: "#000050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.87,45c5.6-3.84,5.83-5.34.96-9-7.86-5.91-13.15-7.29-18.52-9.46,7.19,4,16.78,10.23,15.97,14.62-1.28,6.96-13.31,10.22-13.31,10.22.18-.01,2.15-.37,4.22-1.27,1.3-.56,7.12-2.67,10.68-5.11h0Z",
    fill: "#b21f2d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m48.72,22.62s3.39,1.58,7.59,3.92c5.37,2.17,10.66,3.55,18.52,9.46,4.87,3.66,4.64,5.17-.96,9-3.56,2.44-9.38,4.54-10.68,5.11-2.07.9-4.05,1.25-4.22,1.27-.93.06-1.82-.11-2.68-.4-.75-.25-1.49-.52-2.27-.65-.4-.07-.8-.06-1.2.08-.39.13-.78.25-1.17.37-.07.02-.13.05-.19.09-.2.13-.24.24-.17.46.09.31.18.61.27.92.04.12.07.24.11.37-.08.02-.13.04-.19.06-.95.3-1.9.61-2.85.91-.15.05-.29.1-.39.24-.16.22-.18.5-.02.72.14.2.4.29.66.2.84-.27,1.67-.53,2.51-.8.2-.06.4-.13.61-.2.44,1.52.88,3.02,1.33,4.54-.06.02-.11.04-.16.05-.98.31-1.97.63-2.95.94-.42.13-.58.6-.33.93.15.21.42.28.73.18.96-.31,1.92-.61,2.88-.92.05-.02.11-.04.18-.06.02.07.04.12.05.17.11.39.23.77.34,1.16.04.15.14.24.29.25.1.01.22,0,.31-.02.43-.13.86-.25,1.27-.41.23-.09.46-.22.66-.37.46-.35.81-.8,1.17-1.25.42-.53.8-1.07,1.24-1.58.43-.5,1.58-1.25,1.58-1.23,0-.02.06-.05.13-.09.22-.11.66-.25.73-.27,2.59-1.08,5.18-2.14,7.73-3.31,2.68-1.23,5.34-2.57,7.79-4.22,1.86-1.25,3.93-2.81,4.83-4.93.15-.35.26-.71.31-1.09,1.41-9.88-25.35-18.16-33.36-19.61h0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m44.12,27.69c-5.55-3.9-7.05-3.59-8.77,2.26-2.78,9.44-2.22,14.87-2.37,20.67,1.23-8.14,3.7-19.3,8.1-20.08,6.97-1.24,14.23,8.89,14.23,8.89-.07-.16-1.1-1.89-2.66-3.51-.99-1.02-5-5.74-8.52-8.21Z",
    fill: "#b21f2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.69,44.1c-.62-.79-1.25-1.58-1.87-2.38-.04-.04-.07-.09-.12-.15.06-.04.1-.07.14-.11.32-.24.64-.49.96-.72.13-.09.18-.21.14-.36-.03-.1-.07-.2-.13-.29-.27-.35-.53-.71-.83-1.05-.16-.19-.37-.35-.58-.49-.49-.31-1.03-.48-1.58-.66-.64-.2-1.28-.38-1.91-.61-.62-.23-1.73-1.04-1.7-1.05-.02,0-.07-.03-.13-.09-.18-.17-.46-.53-.51-.58-1.92-2.04-3.82-4.11-5.81-6.08-2.1-2.08-4.28-4.1-6.68-5.82-1.82-1.3-4.01-2.7-6.32-2.79-.38-.01-.76,0-1.13.09-9.75,2.14-8.13,30.1-6.68,38.11,0,0,.29-3.72,1.01-8.48.15-5.79-.41-11.23,2.37-20.67,1.72-5.85,3.22-6.16,8.77-2.26,3.53,2.48,7.54,7.19,8.52,8.21,1.56,1.62,2.59,3.35,2.66,3.51.38.84.53,1.75.56,2.65.03.79.04,1.58.19,2.35.08.4.23.77.49,1.1.26.32.51.64.76.96.04.06.09.11.15.15.19.14.31.14.49,0,.25-.19.51-.38.76-.57.1-.07.2-.15.31-.23.05.06.09.11.12.16.62.78,1.24,1.57,1.86,2.35.1.12.2.24.36.28.27.08.53-.01.68-.23.14-.2.13-.48-.04-.69-.54-.69-1.08-1.38-1.63-2.07-.13-.16-.26-.33-.39-.5,1.27-.95,2.52-1.89,3.79-2.83.04.05.07.09.11.13.64.81,1.27,1.62,1.91,2.43.27.34.77.33.99-.01.15-.22.11-.49-.09-.74h0Z",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41.1,62.96c-.27,6.78.8,7.87,6.64,6.15,9.44-2.77,13.71-6.18,18.66-9.19-7.5,3.37-18.23,7.33-21.27,4.06-4.82-5.19-.23-16.78-.23-16.78-.1.15-.99,1.94-1.51,4.14-.32,1.38-2.12,7.31-2.29,11.61h0Z",
    fill: "#b21f2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.69,35.09c-.33.95-.65,1.91-.99,2.86-.02.05-.04.11-.06.18-.07-.03-.12-.04-.16-.06-.38-.14-.75-.27-1.13-.42-.15-.06-.27-.03-.38.08-.07.08-.13.17-.17.26-.15.42-.31.84-.43,1.26-.07.24-.1.5-.1.75,0,.58.15,1.13.3,1.68.17.65.38,1.28.52,1.94.15.65.06,2.02.04,2,.01.02.01.08,0,.16-.05.24-.2.68-.21.74-.68,2.72-1.39,5.43-1.97,8.18-.61,2.89-1.13,5.82-1.28,8.77-.11,2.23-.1,4.83,1.07,6.83.19.33.42.63.69.9,7.07,7.04,29.71-9.46,35.66-15.01,0,0-3.29,1.77-7.68,3.74-4.95,3.01-9.22,6.42-18.66,9.19-5.85,1.72-6.92.63-6.64-6.15.17-4.31,1.96-10.23,2.29-11.61.52-2.2,1.41-3.99,1.51-4.14.5-.78,1.18-1.39,1.93-1.91.65-.45,1.3-.88,1.88-1.44.3-.28.52-.61.65-1.01.13-.39.27-.77.4-1.16.02-.07.04-.14.04-.2.01-.23-.05-.33-.27-.42-.3-.11-.6-.22-.89-.33-.11-.04-.23-.08-.36-.13.03-.08.05-.13.06-.19.32-.94.65-1.89.97-2.84.05-.15.09-.3.04-.46-.08-.26-.3-.44-.56-.45-.25,0-.47.15-.56.41-.29.83-.57,1.66-.86,2.49-.07.2-.14.4-.21.61-1.48-.55-2.95-1.1-4.43-1.65.02-.06.04-.11.06-.16.34-.98.68-1.95,1.01-2.93.14-.41-.14-.82-.55-.82-.26,0-.47.17-.58.47h0Z",
    fill: "url(#linear-gradient-3)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 13,
    r: 10,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 13,
    r: 7,
    fill: "#f43131"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeZoneRed);
export default __webpack_public_path__ + "static/media/ChargeZone_red.63173eca1bafc02ab5be0b7b9cb28b69.svg";
export { ForwardRef as ReactComponent };